import Head from 'next/head'
import { HomeApp } from '~/home/HomeApp'
import { useMsg } from '~/common/localizationUtils'

export default function HomePage() {
  const msg = useMsg()
  return (
    <>
      <Head>
        <title>{msg('home.page.title')}</title>
      </Head>
      <HomeApp />
    </>
  )
}
